import enLocale from "element-ui/lib/locale/lang/en";
import SearchLeads from "../../views/company/list/SearchLeads.vue";
const en = {
  login: {
    buttoo: {
      add: "add",
    },
  },
  dialog: {
    buttton: {
      close: "Close",
    },
    ReportError: {
      next: "Next",
      h1: "Report Errors allows users to communicate with us to solve any data issues and improve data quality.",
      li1: "If you find any data problems or have a question about this data",
      li2: "If you want to contribute company information to improve this data",
      li3: "If you choose not to disclose your own company information that you might consider private",
      li4: "If you have any constructive suggestions for us to improve services",
      h2: "All comments submitted are subject to data verification. Users must complete your own user profile as our representative may contact you for authentication and verification of your company any rights to represent your company.",
      Iamanemployeeofthissubjectcompany:
        "I am an employee of this subject company",
      Reportmycompany: "Report my company",
      Updatedata: "Update data",
      Reportinformationerrors: "Report information errors",
      Reportotherscompany: "Report others company",
      Financial: "Financials",
      Pleaseprovidemoreinfo: "Please provide more info",
      Year: "Year",
      Business: "Business",
      Noofemployees: "No. of employees",
      Coremanagement: "Core management",
      Corebusinessactivites: "Core business activites",
      IntBusiness: "Int' Business",
      Pleasedescribeyouractivites: "Please describe your activites",
      Pleaselistcountriesyoudobusine: "Please list countries you do busine",
      Corecompetency: "Core competency",
      Businessoutlook: "Business outlook",
      Uploadfiles: "Upload files",
      Upload: "Upload",
      Cancel: "Cancel",
      Submit: "Submit",
      Select: "Select",
      Selectthedatacategoryyoureport: "Select the data category you report",
      TotalCurrentAssets: "Total Current Assets",
      CashBank: "Cash & Bank",
      Accountreceivable: "Account receivable",
      AdvancestoSuppliers: "Advances to Suppliers",
      Inventory: "Inventory",
      Tobeappointedexpense: "To be appointed expense",
      Totalnoncurrentassets: "Total non-current assets",
      Longterminvestment: "Long-term investment",
      Fixedassetsnetvalue: "Fixed assets net value",
      Projectsunderconstruction: "Projects under construction",
      Longtermtobeappointedexpenise: "Long-term to be appointed expenise",
      Deferredtaxdebit: "Deferred tax debit",
      Totalcurrentliabilities: "Total current liabilities",
      Accountpayable: "Account payable",
      Advancesfromclients: "Advances from clients",
      Salariespayable: "Salaries payable",
      Taxespayable: "Taxes payable",
      Otheraccountspayable: "Other accounts payable",
      Totalequity: "Total equity",
      Paidupcapital: "Paid up capital",
      Capitalreserves: "Capital reserves",
      Surplusreserves: "Surplus reserves",
      Undistrbutedporfit: "Undistrbuted porfit",
      Totalassets: "Total assets",
      Turnover: "Turnover",
      Costofgoodssold: "Cost of goods sold",
      Salestax: "Sales tax",
      Grossprofit: "Gross profit",
      Otheroperatingprofils: "Other operating profils",
      Salesexpense: "Sales expense",
      Managementexpense: "Management expense",
      Financeexpense: "Finance expense",
      Operatingprofit: "Operating profit",
      Nonoperatingincome: "Non-operating income",
      Profitbeforetax: "Profit before tax",
      Incometax: "Income tax",
      Netincome: "Net income",
      DataProblems: "Data Problems",
      CorrectInformation: "Correct Information",
    },
  },
  Home: {
    Applications: "Applications",
    SearchCompanies: "Search Companies",
    SearchLeads: "Search Leads",
    SearchTrade: "Search Trade",
    SearchSanctions: "Search Sanctions",
    SearchNews: "Search News",
    RiskScan: "Risk Scan",
    SearchRelationship: "Search Relationship",
    DataServices: "Data Services",
    SearchCountries: "Search Countries",
    selectCountry: "Select Country",
    Entercompanyname: "Enter company name",
    keWord: "Keyword", //关键词
    firstWord: "Exact Left", //首词
    search: "Search", //搜索
    homeSeachTitle: "Bringing Global Business Into Focus", //聚焦全球商情
    homeTitleDetail:
      "CSI, a data-driven research and IT firm, specializes in credit, risk, and big data. It offers digital tools to global investors and business professionals, leveraging advanced analytics and algorithms to provide fast, visual insights that facilitate smarter decision-making.",
    phoneTitleDetail:
      "To quickly search, view, and obtain company information, you can also use the CSI App on your phone.", //您可以使用手机上的 CSI App 快速搜索、查看和获取公司信息。,
    searchCompanyNum:
      "Search 500+ million companies in 200+ countries and territories",
    newsHeadTitle:
      "Uncover the strategic insights behind every company headline",
    sanctionHeadTitle:
      "Navigate international trade with confidence by screening companies and products against global sanctions",
    tradeHeadTitle:
      "Transform global trade data into strategic market insights",
    relationshipTitle:
      "Ultimate Ownership & Control / Investment Footprint / Supply Chain Network / Streamline Compliance / Mitigate Risks / Global Coverage",
    IndustryAnalysis: "Industry Analysis",
    BusinessAnalytics: "Business Analytics",
    ImportExportData: "Import-Export Data",
    CompanyNews: "Company News",
    Sanctions: "Sanctions",
    BusinessIntelligence: "Business Intelligence",
    CompanyIdentityVerification: "Company Identity Verification",
    KYCSolutions: "KYC Solutions",
    OwnershipPenetration: "Ownership Penetration",
    CompanyFinancialAnalysis: "Company Financial Analysis",
    CreditRatings: "Credit Ratings",
    CreditReports: "Credit Reports",
    ESGRatings: "ESG Ratings",
    VendorScreening: "Vendor Screening",
    MarketResearch: "Market Research",
    EnterKeyword: "Enter keywords",
    Country: "Country",
    Company: "Company",
    Person: "Person",
    Product: "Product",
    EnterPersonName: "Enter person name",
    EnterCountryName: "Enter country name",
    EnterproductName: "Enter product keywords",
    EnterproductNamekeywordsorHSCode: "Enter product keywords or HS Code",
    Searchby: "Search by",
    SICStandardIndustryCode: "SIC - Standard Industry Code",
    HSCodeHarmonizedSystemCode: "HSCode - Harmonized System Code",
    AIAssistance: "AI Assistance",
    EnterISICNACENAICSCSICAAAICGICS:
      "Enter ISIC / NACE / NAICS / CSIC / AAAIC / GICS",
    EnterHarmonizedSystemCode: "Enter harmonized system code",
    SIC: "SIC",
    HSCode: "HSCode",
    Tips:"Tips",
    detailconttext:
      "The feature you're attempting to access is part of our premium membership benefits. To gain access to this feature and enjoy full access to premium features, please subscribe to our membership plan.",
    Subscribe: "Subscribe",
  },
  Toolbar: {
    Filter: "Filters",
    Select: "Select",
    Edit: "Edit",
    Sortby: "Sort by",
    Collect: "Collect",
    Saved: "Saved",
    Compare: "Compare",
    Export: "Export",
    Download: "Download",
    Update: "Update",
    Reporterror: "Report Errors",
    Share: "Share",
    ascending: "Ascending",
    descending: "Descending",
    Yourfolder: "Your Folder",
    RiskScanning: "Risk Scanning",
    CreditAssessment: "Credit Assessment",
    DataAnalysis: "Data Analysis",
    NewPortfolio: "New Portfolio",
    Print: "Print",
    Optimize: "Optimize",
    ALL: "ALL",
    Confirm: "Confirm",
  },
  Export: {
    Choosethedatafields: "Choose the data fields you'd like to export.",
    Enterkeywords: "Enter keywords",
    Financialdata: "Financial data",
    Reset: "Reset",
    Back: "Back",
    Howmanyresults:
      "How many results would you like to export form this search? You may also define your search by including additional filter(s).",
    FileName: "File Name",
    Pleaseenterafilename: "Please enter a file name",
    SelectedList: "Selected List",
  },
  AiZaba: {
    whatareyousearchingfor: "What are you searching for?",
    CreditAnalyst: "Credit Analyst",
    Assesses:
      "Assesses a company's credit worthiness, identifies financial risks, ensuring secure transactions through data analysis and credit ratings.",
    LegalAdvisor: "Legal Advisor",
    Provides:
      "Provides compliance guidance, reviews contracts, and assesses legal risks to ensure business operations align with laws and avoid disputes.",
    BizConsultant: "Biz Consultant",
    Optimizes:
      "Optimizes supply chains, identifies buyers, and boosts sales by analyzing market trends and offering tailored strategies to improve efficiency.",
    EconomicAnalyst: "Economic Analyst",
    Analyzes:
      "Analyzes industry and regional economic trends, helping businesses make informed decisions, and stay competitive.",
    HiImZabaYourresearchassistant: "Hi I'm Zaba - Your research assistant",
  },
  navigationBar: {
    Notifications: "Notifications", //通知
    MarkasRead: "Mark as Read", //标记已读
    Viewall: "View all", //查看全部
    SilverSubscriber: "Silver Member", //银级用户
    GoldSubscriber: "Gold Member", //金级用户
    SubscriptionExpires: "Subscription Expires",
    AvailableCredits: "Available Credits", //可用积分
    AddCredits: "Add Credits", //购买积分
    IndivdualAccount: "Personal Account", //个人账号
    GroupAccount: "Corporate Account", //集团账号
    UserAccount: "User Account",
    Roles: "Roles", //角色
    Thereiscurrentlynonewnews: "There is currently no new news",
    EnterTitleContent:"Enter Title Content",
  },
  ListofResults: {
    Country: "Country",
    Industry: "Industry",
    CompanyType: "Co. Type",
    CompanySize: "Co. Size",
    CompanyStatus: "Co. Status",
    CompanyName: "Co. Name",
    RegStatus: "Reg. Status",
    StateProvince: "State/Province",
    CityCounty: "City/County",
    DistrictCity: "District/City",
    IncDate: "Inc. Date",
    LegalForm: "Legal Form",
    CoID: "Co. ID",
    TaxNo: "Tax No",
    ListingInfo: "Listing Info",
    Phone: "Phone",
    Website: "Website",
    Email: "Email",
    LegalPerson: "Legal Person",
    PostCode: "Post Code",
    ISIC: "ISIC",
    IndustryDescription: "Industry Description",
    NACE: "NACE",
    NAICS: "NAICS",
    CreditRating: "Credit Rating",
    SolvencyIndex: "Solvency Index",
    ProbabilityofDefault: "Probability of Default",
    NoofEmployees: "No. of Employees",
    Revenue: "Revenue",
    TotalAsset: "Total Asset",
    NetProfit: "Net Profit",
    ROA: "ROA",
    ROE: "ROE",
    ShowMore: "Show More",
    SelectCountry: "Select Country",
    ClearAll: "Clear All",
    SelectIndustry: "Select Industry",
    ListedCompany: "Listed Company",
    YearsinBusiness: "Years in Business",
    Sharethisinformation: "Share this information",
    Pleaseaddress: "Please enter one or more email address",
    Example: "Example",
    message: "Message",
    pleaseleaveamessage: "Please leave a message",
    Include: "Include",
    thisaddress: "this company name , ID , address",
    CSIwebsite: "CSI website",
    Update: "Update",
    Iftheavailable:
      "If the available online data is insufficient or outdated, you can click the “Update” button to request an instant update for a fresh investigated business credit report from our local networking investigators or credit reporting agencies. The cost for this update is 1 credit per company. The update report typically takes between 24 and 72 hours to be delivered.",
    Abusinesscredit:
      "A business credit report provides detailed information about the subject company's identification data, registry records, shareholding structure, company history, management description, related companies, actual operations, trade references, financial data and analysis, official public information such as litigation records and sanctions, and credit analysis and assessment.",
    Searchcompanies: "Search more emails on other companies",
    Rowsperpage: "Rows per page",
    Remove: "Remove",
    Confirm: "Confirm",
  },
  ContentTabs: {
    Background: "Background",
    BusinessActivities: "Business Activities",
    Performance: "Performance",
    Publications: "Publications",
    CreditOpinion: "Credit Opinion",
    MarketAnalysis: "Market Analysis",
    Snapshot: "Snapshot",
    Profile: "Profile",
    Ownership: "Ownership",
    RelatedCompanies: "Related Companies",
    Management: "Management",
    Operations: "Operations",
    Locations: "Locations",
    Industry: "Industry",
    ImportExport: "Import & Export",
    SupplyChain: "Supply Chain",
    FinancialHighlights: "Financial Highlights",
    RatioAnalysis: "Ratio Analysis",
    IndustryNorm: "Industry Norm",
    News: "News",
    Sanctions: "Sanctions",
    IndustryStatistics: "Industry Statistics",
    RatingAnalysis: "Rating Analysis",
    CompetitiveAnalysis: "Competitive Analysis",
  },
  Snapshot: {
    CompanyDQIdesc1:
      "The Data Quality Index (DQI) employs algorithms to assess different aspects of data, including completeness, validity, reliability of sources, consistency, timeliness, and bilingual support.",
    CompanyDQIdesc2:
      "The index is designed to assess the quality of data on a scale of 1 to 100, with higher scores indicating superior data quality. Algorithms can analyze data based on predefined rules or criteria, enabling objective and standardized measurements.",
    CompanyDQIdesc3:
      "Our Data Quality Index (DQI) serves as a reliable indicator, allowing users to quantitatively assess data quality. This enables data-driven decision-making and enhances the overall value and utility of the data.",
    CountryDQIdesc1:
      "The Data Quality Index (DQI) assesses the reliability, accuracy, and accessibility of data across countries, reflecting differences in digital infrastructure, governance, and transparency. Developed nations typically rank higher due to strong data systems, open policies, and advanced technology, while developing economies often struggle with gaps in infrastructure, regulation, or data-sharing practices.",
    CountryDQIdesc2:
      "Key factors include government transparency, data protection laws, and technological adoption. A high DQI enables better policymaking and business decisions, while a low score highlights areas needing investment.",
    CompanyDQI: "Company DQI", //公司数据质量指数 DQI
    CountryDQI: "Country DQI", //国家数据质量指数 DQI
    CompanyTitle: "Data Quality Index (DQI) by Company",
    CountryTitle: "Data Quality Index (DQI) by Country",
    Address: "Address", //地址
    CountyCity: "County/City", //县/市
    ProvinceState: "Province/State", //省/州
    CountryRegion: "Country/Region", //国家/地区
    ZipCode: "Zip Code", //邮政编码
    Website: "Website", //网站
    Email: "Email", //电邮
    Tel: "Tel", //电话
    LastUpdate: "Last Update", //最近更新
    DataSource: "Data Source", //数据来源
    LegalStatus: "Legal Status", //法定状况
    CoID: "Co. ID", //公司ID
    CompanyType: "Co. Type", //公司类型
    RegistrationDate: "Registration Date", //注册日期
    RegistrationStatus: "Registration Status", //注册状态
    Listed: "Listed", //上市信息
    CurrentOpperations: "Current Operations", //经营状况
    IndustryCode: "Industry Code", //行业代码
    BusinessActivities: "Business Activities", //主营业务
    NoofEmployees: "No. of Employees", //员工数量
    NoofShareholders: "No. of Shareholders", //股东数量
    Management: "Management", //管理状况
    Performance: "Performance", //业绩表现
    Revenue: "Revenue", //收入
    Assets: "Assets", //资产
    ProfitLoss: "Profit/Loss", //利润
    Growth: "Growth", //公司增长
    Competitiveness: "Competitiveness", //竞争力
    CreditOpinion: "Credit Opinion", //信用状况
    CreditRating: "Credit Rating", //信用评级
    CreditScore: "Credit Score", //信用评分
    ESGRating: "ESG Rating", //ESG 评级
    Solvency: "Solvency", //偿还能力
    Sanctions: "Sanctions", //全球制裁
    CoName: "Co. Name",
    RegName: "Reg. Name",
  },
  Profile: {
    CompareCompanies: "Compare Companies",
    AddaCompany: "Add a Company",
    SubjectCompany: "Subject Company", //目标公司
    ComparisonCompany: "Comparison Company",
    CompanyProfile: "Company Profile", //基本资料
    CompanyName: "Co. Name", //公司名称
    NativeName: "Native Name", //当地名称
    CompanyID: "Co. ID", //公司 ID
    VATNumber: "VAT Number", //VAT号
    StockCode: "Stock Code", //股票代码
    Listed: "Listed", //上市日期
    RegistrationDate: "Registration Date", //注册日期
    LegalForm: "Legal Form", //公司性质
    CompanyType: "Co. Type", //公司类型
    LegalStatus: "Legal Status", //注册状态
    Jurisdiction: "Jurisdiction", //司法管辖区
    RegisteredAddress: "Registered Address", //注册地址
    ProvinceState: "Province/State", //省/州
    CountryRegion: "Country/Region", //国家/地区
    ZipCode: "Zip Code", //邮政编码
    OperatingAddress: "Operating Address", //经营地址
    LastUpdate: "Last Update", //最近更新
    DataSource: "Data Source", //数据来源
    History: "History", //历史记录
    RegisteredCapital: "Registered Capital",
    PaidinCapital: "Paid-in Capital",
    CountyCity: "County/City",
    OtherName: "Other Name",
  },
  Ownership: {
    TotalPartiesInvolved: "Total Parties Involved",
    UltimateBeneficiaryOwner: "Ultimate Beneficiary Owner (UBO)", //最终受益人
    NaturalPersonShareholder: "Natural Person Shareholders", //涉及自然人股东
    CorporateShareholders: "Corporate Shareholders", //涉及法人股东
    ShareholderLevel: "Shareholding Levels", //股东层级x
    Name: "Name", //名称
    Country: "Country", //国家/地区
    Location: "Location", //地点
    Type: "Type", //类型
    Shares: "Shares", //股份
    Relation: "Relations", //关系
    RelatedCompany: "Related Companies",
    CompanyShareholders: "Co. Shareholders",
    NGOShareholders: "NGO Shareholders",
    SubjectInvestments: "Subject's Investments",
  },
  RelatedCompanies: {
    Total: "Total Entities", //相关公司总计
    Countries: "Countries", //国家/地区
    Branches: "Branches", //分支机构
    RelatedComp: "Related Companies", //关联公司
    Name: "Name", //名称
    Country: "Country", //国家/地区
    Location: "Location", //地点
    Type: "Type", //类型
    Relationship: "Relationship", //关系
    BranchOffices: "Branch Offices",
    Subsidiaries: "Subsidiaries",
  },
  Management: {
    Management: "Management", //管理层
    ContactInfo: "Contact Info", //联系人信息
    Countries: "Countries", //国家/地区
    Name: "Name", //名称
    Position: "Position", //职位
    Department: "Department", //部门
    Country: "Country", //国家/地区
    ShareholderNot: "Shareholder or Not", //是否股东
    Relation: "Relations", //关系
    Verification: "Verification", //已验证
    Searchmoreemails: "Search more emails", //搜索更多电邮
    Roles: "Roles", //角色
    EducationLevel: "Education Level", //教育程度
    Phone: "Phone", //电话
    Email: "Email", //电邮
    Verified: "Verified", //已验证
    Searchmore: "Search more emails on other companies", //搜索更多其他公司的电邮
    Pleaseentername: "Please enter name",
    PleaseenterWebsite: "Please enter company name or domain",
    UserSelfVerification: "User Self Verification",
    Userverified: "User verified",
    Source: "Source",
  },
  Operations: {
    LineofBusiness: "Line of Business", //业务范围
    BusinessTerritories: "Business Territories", //业务区域
    ImportExport: "Import & Export", //进出口信息
    Viewtradeinfo: "View more trade info", //查看更多贸易信息
    ProductsServices: "Products/Services", //产品/服务
    Products: "Products", //产品
    ProductImage: "Product Image", //产品图片
    ProductName: "Product Name", //产品名称
    ProductDescription: "Product Description", //产品描述
    Details: "Details", //详情
    Addproductinformation: "Add product information ", //添加产品信息
    Showcaseyourcompany:
      "If you'd like to showcase your company's products or services to the public, you can add your product and service information here. This is a great way to promote your business. Once we’ve reviewed your submission, your data will be published.",
  },
  Locations: {
    CoName: "Co. Name", //业务范围
    Relationship: "Relationship", //关系
    Type: "Type", //类型
    Country: "Country", //国家/地区
    Location: "Location", //地点
    Address: "Address", //地址
    Edit: "Edit", //编辑
    CompanyLocatiionsMap: "Company Locations in Map", //地图中的公司位置
    Selectaddresstype: "Select address type", //选择地址类型
    Subjectcompany: "Subject company", //目标公司
    Subsidiary: "Subsidiary", //子公司
    RegisteredAddress: "Registered Address", //注册地址
    OperationAddress: "Operation Address", //运营地址
    All: "All", //全部
    Showlocation: "Show location",
  },
  Industry: {
    IndustryTitle: "Industry Title", //IndustryTitle
    IndustryDescription: "Industry Description", //IndustryDescription
    ISIC: "ISIC", //ISIC
    ISICDescription: "ISIC Description", //ISICDescription
    NACE: "NACE", //NACEDescription
    NACEDescription: "NACE Description", //NACEDescription
    NAICS: "NAICS", //NAICS
    NAICSDescription: "NAICS Description", //NAICSDescription
    CSIC: "CSIC", //CSIC,
    CSICDescription: "CSIC Description", //CSICDescription
    AAAIC: "AAAIC", //AAAIC
    AAAICDescription: "AAAIC Description", //AAAICDescription
    GICS: "GICS", //GICS
    GICSDescriptio: "GICS Descriptio", //GICS 描述
  },
  ImportExport: {
    TotalImportAmount: "Total Import Amount", //进口总额
    TopImportCountry: "Top Import Country", //最大进口国家/地区
    TopImportProduct: "Top Import Product", //最大进口产品
    TotalExport: "Total Export Amount", //出口总额
    TopExportCountry: "Top Export Country", //最大出口国家/地区
    TopExportProduct: "Top Export Product", //最大出口产品
    TradeVolume: "Trade Volume", //贸易额
    ImportShipments: "Import Shipments", //进口量
    ExportShipments: "Export Shipments", //出口量
    ImportCountries: "Import Countries", //进口国家/地区
    ExportCountries: "Export Countries", //出口国家/地区
    ImportVolume: "Import Volume ", //进口量
    ExportVolume: "Export Volume", //出口量
    Suppliers: "Top Suppliers", //主要供应商
    Shipments: "By No. of Shipments", //按出货量
    Buyers: "Top Buyers", //主要买家
    ImportQuantity: "Import Quantity", //进口数量
    IncreaseDecreasexRate: "Increase/Decrease Rate", //增/减率
    ExportQuantity: "Export Quantity", //出口数量
    ImportsExportsRecords: "Imports & Exports Records", //进出口记录
    Date: "Date", //日期
    Product: "Product", //产品
    HSCode: "HS Code", //HS 编码
    BuyerName: "Buyer Name", //买家名称
    Destination: "Destination", //目的地
    SupplierName: "Supplier Name", //供应商名称
    Origin: "Origin", //原产地
    Amount: "Amount (USD)", //金额
    Details: "Details", //详情
    Imports: "Imports",
    Exports: "Exports",
    Shipments2: "Shipments",
    value2: "value",
    value: "By No. of value",
    viewmoretradeinfo: "view more trade info",
    SearchHSCode: "Search HS Code",
    Selectdate: "Select date",
  },
  SupplyChain: {
    Illustratesthesubjectcompany:
      "This chart illustrates the subject company's “buy from” and “sell to” relationships. The larger the volume, the thicker the tube.",
  },
  ShippingOrderDetails: {
    Date: "Date",
    MasterBillofLading: "Master Bill of Lading",
    Source: "Source",
    BillNo: "Bill No",
    ImporterBuyer: "Importer / Buyer",
    ExporterSeller: "Exporter / Seller",
    Name: "Name",
    Address: "Address",
    Country: "Country",
    Contact: "Contact",
    Email: "Email",
    CargoInfo: "Cargo Info",
    HSCode: "HS Code",
    Quantity: "Quantity",
    WeightUnit: "Weight Unit",
    ProductDescription: "Product Description",
    Amount: "Amount (USD)",
    QuantityUnit: "Quantity Unit",
    Weight: "Weight",
    HSDescription: "HS Description",
    Incoterms: "Incoterms",
    ShippingInfo: "Shipping Info",
    Vessel: "Vessel",
    Consignee: "Consignee",
    MeansofTransport: "Means of Transport",
    CountryofOrigin: "Country of Origin",
    Voyage: "Voyage",
    Notifier: "Notifier",
    CountryofDestnation: "Country of Destnation",
    AddressofOrigin: "Address of Origin",
    Shipper: "Shipper",
    AddressofDestnation: "Address of Destnation",
    Container: "Container",
    ContainerID: "Container ID",
    ContainerType: "Container Type",
    ContainerDescDode: "Container Desc Dode",
    ContainerSize: "Container Size",
    ImportExport: "Importer / Exporter",
    Imports: "Imports",
    Exports: "Exports",
  },
  FinancialHighlight: {
    Revenue: "Revenue", //收入
    Profit: "Profit", //利润
    Growth: "Growth", //增长
    CashFlowStatus: "Cash Flow Status", //现金流状况
    FinancialStructure: "Financial Structure", //融资结构
    CreditOpinion: "Credit Opinion", //信用评估
    RiskIndicator: "Risk Indicator ", //风险指标
    Solvencyindex: "Solvency Index", //偿还指数
    Year: "Year", //年份
    Change: "Change", //变化
    NetProfit: "Net Profit",
    TotalAssets: "Total Assets",
    Equity: "Equity",
    GrossMargin: "Gross Margin",
    ProfitMargin: "Profit Margin",
    ReturnonEquity: "Return on Equity",
    CurrentRatio: "Current Ratio",
    DebtRatio: "Debt Ratio",
    FinancialHighlights: "Financial data from the related companies", //关联公司财务数据
    FinancialHighlightsTitle: "Financial Highlights from the Related Companies", //关联公司财务摘要
    CompanyName: "Co. Name", //公司名称
    CompanyID: "Co. ID", //公司ID
    Country: "Country", //国家/地区
    CompanyStatus: "Co. Status", //公司状态
    Cancel: "Cancel", //取消
    Select: "Select",
    Relations: "Relations", //关系
    Financialperformancedata:
      "Financial performance data is collected from various governmental sources and local credit reporting agencies. Additionally, market and industry research is used to calculate and model the data. For more detailed information about the actual operations and performance analysis, please contact our service team to request a company due diligence report.",
    Whenthesubjectsdata:
      "When the subject's data is insufficient, or you're interested in gaining more insights into your customer, this platform offers a comprehensive view of all entities related to the subject. This includes the subject's company's shareholders, related companies, and more.",
    Byprovidingyou:
      "By providing you with a broader perspective, this platform empowers you to make more informed evaluations and gain a deeper understanding of your subject.",
    PleaseSelectTheYeartoDisplay: "Please Select The Year to Display",
    SelectUptoThreeYears: "Select Up to Three Years",
  },
  RatioAnalysis: {
    ProfitabilityRatios: "Profitability Ratios",
    Year: "Year", //年份
    Change: "Change", //变化
    Returnonequity: "Return on equity",
    Returnonassets: "Return on assets",
    Profitmargin: "Profit margin",
    Grossmargin: "Gross margin",
    OperatingRatios: "Operating Ratios",
    Assetsturnover: "Assets turnover",
    Stockturnover: "Stock turnover",
    Salesperiod: "Sales period",
    Collectionperiod: "Collection period",
    Creditperiod: "Credit period",
    StructuralRatios: "Structural Ratios",
    Currentratio: "Current ratio",
    Quickratio: "Quick ratio",
    Shareholdersliquidityratio: "Shareholders liquidity ratio",
    Solvencyratio: "Solvency ratio",
    Debtratio: "Debt ratio",
    ProductivityRatios: "Productivity Ratios",
    Profitperemployee: "Profit per employee",
    Operatingrevenueperemployee: "Operating revenue per employee",
    Shareholdersfundsperemployee: "Shareholders funds per employee",
    Totalassetsperemployee: "Total assets per employee",
    GrowthRatios: "Growth Ratios",
    Salesgrowthrate: "Sales growth rate",
    Netprofitgrowthrate: "Net profit growth rate",
    Totalassetsgrowthrate: "Total assets growth rate",
    FinancialHighlights: "Financial data from the related companies", //关联公司财务数据
    RatioAnalysis: "Ratio Analysis from the Related Companies", //关联公司比率分析
    CompanyName: "Co. Name",
    CompanyID: "Co. ID",
    Country: "Country",
    CompanyStatus: "Co. Status",
    Relations: "Relations",
  },
  IndustryNorms: {
    IndustryStatistics: "Industry Statistics",
    ofcompaniesintheIndustry: "No. of companies in the Industry",
    oflistedCompaniesintheIndustry: "No. of listed Companies in the Industry",
    oflargecompaniesintheIndustry: "No. of large companies in the Industry",
    ofSMEsintheIndustry: "No. of SMEs in the Industry",
    ofcompaniesinsample: "No. of companies in sample",
    ofcompaniesinloss: "No. of companies in loss",
    Observations: "Observations",
    AverageValue: "Average Value",
    MedianValue: "Median Value",
    MaximumValue10: "Maximum Value 10%",
    MinimumValue10: "Minimum Value 10%",
    SubjectCompany: "Subject Company",
    YearsinBusiness: "Years in Business",
    TotalAssets: "Total Assets",
    TotalEquity: "Total Equity",
    Revenue: "Revenue",
    NetEarning: "Net Earning",
    Returnonassets: "Return on assets",
    Performance: "Performance",
    ProfitabilityRatios: "Profitability Ratios",
    Returnonequity: "Return on equity",
    Grossmargin: "Gross margin",
    OperatingRatios: "Operating Ratios",
    Stockturnover: "Stock turnover",
    Accountsreceivableturnover: "Accounts receivable turnover",
    Assetsturnover: "Assets turnover",
    Totalassetturnover: "Total asset turnover",
    StructuralRatios: "Structural Ratios",
    Currentratio: "Current ratio",
    Quickratio: "Quick ratio",
    Shareholdersliquidityratio: "Shareholders liquidity ratio",
    GrowthRatios: "Growth Ratios",
    Salesgrowthrate: "Sales growth rate",
    Netprofitgrowthrate: "Net profit growth rate",
    Totalassetsgrowthrate: "Total assets growth rate",
  },
  Lawsutis: {
    Litigations: "Litigations",
    Date: "Date",
    CaseType: "Case Type",
    Title: "Case Title",
    CaseNo: "Case No.",
    CauseofAction: "Cause of Actions",
  },
  News: {
    Date: "Date", //日期
    Title: "Title", //标题
    Source: "Source", //来源
    Impact: "Impact", //影响
    Searchcompanies: "Search more news on other companies", //国家/地区
    SearchforTitle: "Search for Title",
    CompanyName: "Co. Name",
    Industry: "Industry",
    Subjects: "Subjects",
    NewsTypes: "News Types",
    ByDate: "By Date",
    SelectCompanyName: "Select Company Name",
    SelectIndustry: "Select Industry",
    SelectSubjects: "Select Subjects",
    SelectNewsType: "Select News Type",
    Negative: "Negative",
    Positive: "Positive",
  },
  Sanctions: {
    Potentialcompliance: "Potential compliance risks is detected", //检测到潜在合规风险
    SeachbuttonNo: "Nothing detrimental is detected about this company", //未检测到任何与该公司相关的不良记录
    SeachbuttonYes:
      'To search for more sanction records, please clickon the"Search Sanctions" button.', //要搜索更多制裁记录，请点击“搜索制裁”按钮。
    SearchSanctions: "Search Sanctions", //搜索制裁
    ViewDetails: "View Details", //查看详情
    Sanctions: "Sanctions", //制裁
    Potentialcompliancerisks: "Potential compliance risks", //潜在合规风险
    IDInfo: "ID Info", //ID 信息
    IDType: "ID Type", //ID 类型
    IDDescription: "ID Description", //ID 描述
    SanctionList: "Sanction List", //制裁名单
    SanctionListInvolved: "Sanction List Involved", //涉及的制裁名单
    StartDate: "Start Date", //生效日期
    EndDate: "End Date", //结束日期
    SourceList: "Source List", //来源名单
    SourceName: "Source Name", //来源名称
    ProfileNotes: "Profile Notes", //主体资料
    Link: "Link", //链接
    Name: "Name",
    AssociationList: "Association List",
    AssociationID: "Association ID",
    AssociationType: "Association Type",
  },
  CreditOpinion: {
    CreditAssessment: "Credit Assessment",
    CreditAssessmentfromtheRelatedCompanies:
      "Credit Assessment from the Related Companies",
    Year: "Year",
    CreditRating: "Credit Rating",
    LocalCreditScore: "Local Credit Score",
    ProbabilityofDefault: "Probability of Default",
    SolvencyIndex: "Solvency Index",
    CreditLine: "Credit Line",
    RiskIndicator: "Risk Indicator",
    RelatedCreditAssessment: "Related Credit Assessment",
    CompanyName: "Co. Name",
    CompanyID: "Co. ID",
    Country: "Country",
    CompanyStatus: "Co. Status",
    Relations: "Relations",
    Cancel: "Cancel",
    Select: "Select",
    CreditAssessmentMessage1:
      "When the subject's data is insufficient, or you're interested in gaining more insights into your customer, this platform offers a comprehensive view of all entities related to the subject. This includes the subject's company's shareholders, related companies, and more.",
    CreditAssessmentMessage2:
      "By providing you with a broader perspective, this platform empowers you to make more informed evaluations and gain a deeper understanding of your subject.",
    LocalCreditRating: "Local Credit Rating",
    LocalCreditRatingDetail:
      "Driven by the power of big data, 3ARating is a quantitative rating system for private companies. It is a collaborative effort between 3ACredit and Creditreform Rating. The rating model is built based on a comprehensive evaluation of various key factors, including non-financial factors, financial factors, negative records, and industry-specific considerations. The rating model exhibits an impressive Gini coefficient, indicating its robustness and reliability. 3ARating spans a range of ratings, from the highest rating, 3A1, to the lowest rating class, 3A19.",
    CreditScore: "Credit Score",
    CreditScoreDetail:
      "Credit scores are calculated on a scale from 1 to 100, based on the credit rating obtained from local authorities. A higher score indicates better creditworthiness.",
    PossibilityofDefault: "Possibility of Default (PD)",
    PossibilityofDefaultDetail:
      "The Possibility of Default (PD) is a useful tool for risk assessment, focusing on short-term liquidity evaluation.",
    SolvencyIndexSI: "Solvency Index (SI)",
    SolvencyIndexSIDetail:
      "The Solvency Index (SI) is a highly effective and reliable early warning indicator that allows for a rapid assessment of the solvency of business partners. A higher SI value indicates a higher risk of default by a client. The SI ranges from 100, which is considered an excellent rating, to 600, where highly negative characteristics are present.",
    ExternalRating: "External Rating",
    DefaultProbability: "Default Probability (Pd1Year)",
    Rating: "3ARating (>=,<=)",
    PleaseSelectTheYeartoDisplay: "Please Select The Year to Display",
    SelectUptoThreeYears: "Select Up to Three Years",
    HighRisk: "High Risk",
    Medium: "Medium",
    Moderate: "Moderate",
    Average: "Average",
    LowerThanAvg: "Lower Than Avg",
    LowRisk: "Low Risk",
    CreditOpinion: "Credit Opinion",
  },
  IndustryStatistics: {
    SubjectCompany: "Subject Company",
    Country: "Country",
    Compare: "Compare",
    Industry: "Industry",
    CompanyType: "Co. Type",
    CompanySize: "Co. Size",
    CompanyStatus: "Co. Status",
    YearsinBusiness: "Years in Business",
    CompanyRating: "Co. Rating",
    Liquidity: "Liquidity",
    NoofcoinIndustry: "No. of Co. in Industry",
    IndustryRating: "Industry Rating",
    Profitability: "Profitability",
    Growth: "Growth",
    FinancialStructurt: "Financial Structure",
    Solvency: "Solvency",
    SearchCountry: "Search Country",
  },
  RatingAnalysis: {
    IndustyAnalysis: "Industy Analysis",
    GeographicAnalysis: "Geographic Analysis",
    CompanyTypeAnalysis: "Company Type Analysis",
    BiusinessScaleAnalysis: "Biusiness Scale Analysis",
    HistoryAnalysis: "History Analysis",
    NormalDistribution: "Normal Distribution",
    SubjectCompany: "Subject Company",
    Probabilityofthesubjectratinginitsindustry:
      "Probability of the subject rating in its industry",
    Maximum: "Maximum 10%",
    Mean: "Mean",
    Average: "Average",
    Minimum: "Minimum 10%",
    RatingDistribution: "Rating Distribution",
    Revenue: "Revenue",
    Earning: "Earning",
    TotalAssets: "Total Assets",
    Subjectratinginitsindustrybyfinancialindicators:
      "Subject rating in its industry by financial indicators",
    Best: "Best",
    Worst: "Worst",
    Rankingofsubject: "Ranking of subject's rating in the industry",
    Industy: "Industy",
    Percentilerank:
      "Percentile rank: % of companies that scored at or below subjects rating",
    Historicaldevelopmentofsubject:
      "Historical development of subject's rating in its industry",
    IndustryAverage: "Industry Average",
    SubjectRatingChanges: "Subject Rating Changes",
    CreditScore: "Credit Score",
    NOofCompanies: "No. of Companies",
    ofCompanies: "% of Companies",
    CreditRating: "Credit Rating",
    CompanySize: "Co. Size",
    YearsinBusiness: "Years in Business",
    SubjectsIndustryConcentrationAnalysis:
      "Subject's Industry Concentration Analysis",
    GeographicdistributionofSubjectsratingintsindustry:
      "Geographic distribution of Subject's rating in its industry",
    GeographicdistributioninSubjectindustry:
      "Geographic distribution in Subject's industry",
    RatingDistributioninSubjectsLocation:
      "Rating Distribution in Subject's Location",
    Ratinganalysisofcompanies:
      "Rating analysis of companies in the same industry with different years in business",
    Subjectsratinghistory:
      "Subject's rating history comparing with its peers with the same history",
    Ratingrankingofcompanieswithsamehistory:
      "Rating ranking of companies with same history",
    Ratingstatistics:
      "Rating statistics of companies with the same years in business",
    Subjectratingcomparing:
      "Subject rating comparing with its peer companies with the",
    Subjectratinginitsgroup: "Subject rating in its group",
    Analysisbasedonnature:
      "Analysis based on nature of companies in subject's industry",
    Subjectratingpositioninitscompanytype:
      "Subject rating position in its company type",
    Ratingstatisticsofcompanies:
      "Rating statistics of companies in the same industry",
    Ratinganalysisofcompanies:
      "Rating analysis of companies of different sizes in the same industry",
    Probabilityofsubjectrating:
      "Probability of subject rating in its industry within its size",
    Subjectratingcomparingwithindustry:
      "Subject rating comparing with its peers in its industry:",
    RatingRankingofthecompanies:
      "Rating Ranking of the companies in the same size in the same industry",
    Ratingstatisticsofcompanies:
      "Rating statistics of companies in the same size and same industry",
    Rank: "Rank",
    Rating: "Rating",
    CompanyType: "Co. Type",
  },
  CompetitiveAnalysis: {
    MarketPosition: "Market Position",
    Revenus: "Revenus",
    NetEarnings: "Net Earnings",
    NetAssets: "Net Assets",
    TotalAssets: "Total Assets",
    Employees: "Employees",
    Mean: "Mean",
    Average: "Average",
    Maximum: "Maximum (10%)",
    Worst: "Worst (10%)",
    Subjectcompany: "Subject Company",
    PerformanceComparison: "Performance Comparison",
    ProfitabilityRatios: "Profitability Ratios",
    Grossmargin: "Gross Margin",
    Returnonassets: "Return on Assets",
    Returnonequity: "Return on Equity",
    OperatingRatios: "Operating Ratios",
    Stockturnover: "Stock Turnover",
    Assetsturnover: "Assets Turnover",
    Currentassetturnoverrate: "Current Asset Turnover Rate",
    Collectionperiod: "Collection Period",
    GrowthRatios: "Growth Ratios",
    Totalassetsgrowthrate: "Total Assets Growth Rate",
    Salesgrowthrate: "Sales Growth Rate",
    Netprofitgrowthrate: "Net Profit Growth Rate",
    StructuralRatios: "Structural Ratios",
    Debtratio: "Debt Ratio",
    Quickratio: "Quick Ratio",
    Currentratio: "Current Ratio",
  },
  AccountCenterMenu: {
    SearchinSettings: "Search in Settings", //在“设置”中搜索
    Account: "Account", //账户
    MyAccount: "My Account ", //我的账户
    ContactInfo: "Contact Info", //联系信息
    AccountSecurity: "Account Security", //账户安全
    OrganizationalManagement: "Organizational Management", //组织管理
    UserGroup: "User Group", //用户组
    User: "User", //用户
    Role: "Role", //角色
    MyDatabase: "My Database", //我的数据库
    MyUsage: "My Usage", //我的使用情况
    CompaniesViewed: "Companies Viewed", //查看过的公司
    ReportsDownloaded: "Reports Downloaded", //下载的报告
    ReportUpdatesOrdered: "Report Updates Ordered", //订购的报告更新
    BillingandPayment: "Billing and Payment", //账单和付款
    BillRecords: "Billing Records", //账单记录
    PaymentRecords: "Payment Records", //付款记录
    CreditDeductions: "Credit Deductions", //信用扣款
    InvoicesDownloaded: "Invoices Downloaded", //下载的发票
    UserSettings: "User Settings", //用户设置
    Messages: "Messages", //消息
    Notifications: "Notifications", //通知
    HelpCenter: "Help Center", //帮助中心
    FAQ: "FAQ", //常见问题
    Privacy: "Privacy", //隐私
    Terms: "Terms", //条款
    ReportIssues: "Report Issues", //报告问题
    UserGuide: "User Guide", //用户指南
    AboutCSI: "About CSI", //关于CSI
  },
  MyAccount: {
    Logintime: "Login time", //登录时间
    SignOut: "Sign Out", //退出
    DeleteAccount: "Delete Account", //删除账户
    AccountID: "Account ID", //账户ID
    Enteranewaddress: "Enter a new email address", //输入新的电邮
    EnterVerificationCode: "Enter Verification Code", //输入验证码
    SendverificationCode: "Send verification Code", //发送验证码
    Password: "Password", //密码
    Originalpassword: "Original password", //原始密码
    Newpassword: "New password", //新密码
    Confirmnewpassword: "Confirm new password", //确认新密码
    AccountOwnership: "Account Ownership", //账户所有权
    IndividualAccount: "Personal Account", //个人账户
    GroupAccount: "Corporate Account", //集团账户
    Organizationname: "Organization name", //机构名称
    CountryRegion: "Country/Region", //国家/地区
    Address: "Address", //地址
    City: "City", //城市
    ZipCode: "Zip Code", //邮政编码
    FirstName: "First Name", //名字
    LastName: "Last Name", //姓氏
    PhoneNumber: "Phone Number", //电话号码
    Email: "Email", //更改
    Change: "Change", //更改
    Save: "Save", //保存
    Cancel: "Cancel", //取消
    LastLogin: "Last Login", //上次登录
    RecentLogin: "Recent Login", //登录尝试次数
    AverageLoginTime: "Average Login Time", //平均登录时间
    TotalLoginAttempts: "Total Login Attempts", //登录尝试次数
    Registrationtime: "Registration time",
    Role: "Role",
    Administrator: "Administrator",
    Enterpriseusers: "Enterprise users",
    EditImage: "Edit Image",
    DeleteImage: "Delete Image",
  },
  ContactInfo: {
    ContactInfo: "Contact Info",
    FirstName: "First Name",
    LastName: "Last Name",
    PhoneNumber: "Phone Number",
    Email: "Email",
    CountryRegion: "Country/Region",
    AddressLine: "Address Line",
    City: "City",
    ZipCode: "Zip Code",
    Alternativecontactperson: "Alternative contact person",
    Setascontactperson: "Set as contact person",
    Edit: "Edit",
  },
  AccountSecurity: {
    Setupmysecurityquestions: "Set up my security questions",
    Pleasechooseaquestion: "Please choose a question",
    Pleaseentertheanswertothequestion:
      "Please enter the answer to the question",
    SessionTimeoutAutomaticLogoutSettings:
      "Session Timeout: Automatic Logout Settings",
    Thesystemwillautomatically:
      "The system will automatically log you out after a period of inactivity. The default timeout is set to 5 minutes, but you can adjust this duration as needed.",
  },
  MyDatabase: {
    TotalNumberofCompaniesSearched: "Total No. of Companies Searched",
    TotalNumberofCompaniesCollected: "Total No. of Companies Collected",
    TotalNumberofUpdateReportsOrdered: "Total No. of Update Reports Ordered",
    Date: "Date",
    UserName: "User Name",
    CompanyName: "Co. Name",
    Status: "Status",
    UsageType: "Usage Type",
    Entercompanyname: "Enter company name",
    Download: "Download",
  },
  OrganizationalManagement: {
    GroupName: "Group Name",
    ParentGroupName: "Parent Group Name",
    Organization: "Organization",
    GroupID: "Group ID",
    GroupStatus: "Group Status",
    Operation: "Operation",
    NewlyBuilt: "Newly Built",
    UserAccount: "User Account",
    Role: "Role",
    AccountStatus: "Account Status",
    RoleName: "Role Name",
    Position: "Position",
    RoleStatus: "Role Status",
    Valid: "Valid",
    Invalid: "Invalid",
    PermissionSettings: "Permission Settings",
    ShowMore: "Show More",
    Search: "Search",
    Cancel: "Cancel",
    Confirm: "Confirm",
    NewGroup: "New Group",
    EnterGroupName: "Enter Group Name",
    NumberofGroups: "No. of Groups",
    Groups: "Groups",
    Roles: "Roles",
    NewRoles: "New Roles",
    EnterNewRole: "Enter New Role",
    Users: "Users",
    EnterUserName: "Enter User Name",
  },
  BillingandPayment: {
    TotalNumberofOrders: "Total No. of Orders",
    TotalPaymentAmount: "Total Payment Amount",
    TotalUsedCredits: "Total Used Credits",
    Date: "Date",
    UserAccount: "User Account",
    CompanyName: "Co. Name",
    OrderNo: "Order No.",
    OrderType: "Order Type",
    OrderStatus: "Order Status",
    Download: "Download",
    PaymentAmount: "Payment Amount",
    Contactus: "Contact us",
    DownloadInvoice: "Download Invoice",
    CreditUsage: "Credit Usage",
    ReportOrderStatus: "Report Order Status",
    CompanyID: "Co. ID",
    CountryRegion: "Country/Region",
    AddressLine: "Address Line",
    City: "City",
    ZipCode: "Zip Code",
    FirstName: "First Name",
    LastName: "Last Name",
    PhoneNumber: "Phone Number",
    Email: "Email",
    BankAccountHolderName: "Bank Account Holder Name",
    BeneficiaryBankName: "Beneficiary Bank Name",
    SWIFTCODE: "SWIFT CODE",
    AccountNumber: "Account Number",
    BeneficiaryBankAddress: "Beneficiary Bank Address",
    ABA: "ABA (Routing Number)",
    IBANnumber: "IBAN number",
    StartingMonth: "Starting Month",
    EndMonth: "End Month",
    InvoiceInfo: "Invoice Info",
  },
  UserSettings: {
    LanguageandLocation: "Language and Location",
    Language: "Language",
    Selectyourpreferedlanguage: "Select your prefered language",
    Location: "Location",
    Selectyourlocation: "Select your location",
    NotificationSetting: "Notification Setting",
    EmailNotification: "Email Notification",
    ServiceUpdates: "Service Updates",
    CompanyNews: "Co. News",
  },
  AddCredit: {
    Customizeyourplan: "Customize your plan however you need",
    Silver: "Silver",
    Gold: "Gold",
    Enterpris: "Enterpris",
    Credit: "Credit",
    Remaining: "Remaining {0} points",
    Usermonth: "user/month",
    Useryear: "user/year",
    PaidMonthlyRenews: "Paid monthly, no need for auto renews",
    PaidAnnuallyRenews: "Paid annually, no need for auto renews",
    ForFullSupport: "for full support to your needs",
    Each: "each",
    CreditsCharged:
      "Credits charged to your account will never expire as long as your account remains active.",
    PaidMonthly: "Paid monthly",
    PaidAnnually: "Paid annually",
    BuyNow: "Buy now",
    ContactNow: "Contact now",
    SearchCompanies:
      "Search companies and get an instant access to company data that includes",
    EverythinginSilverPackage: "Everything in Silver package, plus",
    CreditsCanbeUsed:
      "Credits can be used for more data services including the followings",
    UnlimitedAdvancedSearch: "Unlimited advanced search",
    ViewCompanyProfile: "View company profile",
    CompanyOwnershipStructure: "Company ownership structure",
    CompanyFamilyTree: "Company family tree",
    Companymanagement: "Company management",
    CompanyContactsinfo: "Company contacts info",
    BusinessActivities: "Business activities",
    IndustryBasics: "Industry basics",
    ImportExportRecords: "Import & export records",
    CompanyPublications: "Company publications",
    CompanyNews: "Co. news",
    DownloadOnlineReport: "Download online report",
    ManagementDetails: "Management details",
    ShareholderPenetration: "Shareholder penetration (UBO)",
    Financialinfo: "Financial info",
    FinancialAnalysis: "Financial analysis",
    CreditAssessment: "Credit Assessment",
    IndustryAnalysis: "Industry analysis",
    MarketAnalysis: "Market analysis",
    SupplyChaininfo: "Supply Chain info",
    CheckSanctions: "Check sanctions",
    CompanyComparison: "Company comparison",
    DataExport: "Data export",
    MonitoringService: "Monitoring service",
    DiscountForFreshUpdateReports: "Discount for fresh update reports",
    SearchCompany: "Search Company",
    SearchLeads: "Search Leads",
    SearchTrade: "Search Trade",
    SearchPeople: "Search People",
    SearchCountry: "Search Country",
    SearchNews: "Search News",
    SearchSanction: "Search Sanction",
    DataServices: "Data Services",
    APIPlans: "API Plans",
    VolumeDiscounts: "Volume Discounts",
    GroupAccountsWithMultipleUsers: "Group Accounts with multiple users",
    CustomizedPlans: "Customized Plans",
    FreshInvestigatedCreditReportsWorldwide:
      "Fresh investigated credit reports worldwide",
    BusinessMonitoringServices: "Business monitoring services",
    BusinessProcessVerificationServices:
      "Business process verification services",
    VendorComplianceReports: "Vendor compliance reports",
    MarketResearch: "Market research",
    More: "More…",
    Contactus: "Contact us",
    PaymentMethod: "Payment Method",
    CreditCardNumber: "Credit Card Number",
    EnterCardNumber: "Enter Card Number",
    ExpirationDate: "Expiration Date",
    Fullnameoncard: "Full name on card",
    EnterFullname: "Enter Full name",
    EnterProvinceState: "Enter Province / State",
    CVCCode: "CVC Code",
    EnterCVCCode: "Enter CVC Code",
    TotalPurchase: "Total Purchase",
    Agree1: "By clicking “Submit”, you agree to the ",
    Agree2: "CSI Services Agreement and Privacy.",
    Submit: "Submit",
    Month: "Month",
    Year: "Year",
    Country: "Country",
    ProvinceState: "Province/State",
    Cancel: "Cancel",
    IncorrectCreditCardNumberformat: "Incorrect Credit Card Number format",
    IncorrectExpMonthformat: "Incorrect Exp.Month format",
    IncorrectExpYearformat: "Incorrect Exp.Year format",
    IncorrectFullNameformat: "Incorrect Full Name format",
    IncorrectCountryformat: "Incorrect Country format",
    IncorrectProvinceStateformat: "Incorrect Province / State format",
    IncorrectCVCCodeformat: "Incorrect CVC Code format",
  },
  ReportIssues: {
    Whattypeoferrorsyouarereporting: "What type of errors you are reporting?",
    Tellusmoreaboutyourproblems: "Tell us more about your problems.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:
      "Would you like to provide a screenshot or a file regarding your problem?",
    Fillinyourcontactinformation: "Fill in your contact information",
    FirstName: "First Name",
    LastName: "Last Name",
    PhoneNumber: "Phone Number",
    Email: "Email",
    Edit: "Edit",
  },
  //Risk Scan
  RiskScan: {
    RiskScan: "Risk Scan",
    RiskScanInfo:
      " is your all-in-one platform for comprehensive corporate risk intelligence. We provide detailed analysis across every major risk category to safeguard your business decisions.",
    LegalRisk: "Legal Risk",
    LegalRiskInfo: "Verify company's legitimacy.",
    OrganizationalRisk: "Organizational Risk",
    OrganizationalRiskInfo:
      "Management stability, corporate structure complexity, and ownership transparency.",
    OperationalRisk: "Operational Risk",
    OperationalRiskInfo:
      "Supply chain vulnerabilities, operational status, and geopolitical exposure.",
    FinancialRisk: "Financial Risk",
    FinancialPerformanceRiskInfo:
      "Profitability trends, liquidity issues, and balance sheet health.",
    CreditRisk: "Credit Risk",
    CreditRiskInfo:
      "Creditworthiness, payment history, and probability of default.",
    ComplianceRisk: "Compliance Risk",
    ComplianceRiskInfo:
      "Adherence to sanctions, AML regulations, and industry-specific laws",
    SustainabilityRisk: "Sustainability Risk",
    SustainabilityRiskInfo:
      "ESG (Environmental, Social, Governance) factors and reputational impacts.",
    IndustryRisk: "Industry Risk",
    IndustryRiskInfo:
      "Assesses the stability and outlook of a company's entire sector.",
    LetBegin: "Let's Begin",
    AddcompaniesfromSearchResult: "Add companies from Search Result",
    AddcompaniesfromMyDatabase: "Add companies from My Database",
    Addcompaniesbyuploadmyownlist: "Add companies by uploading my own list",
    Uploadyourlistofcompanies:
      "Upload your list of companies, and Risk Scan will provide you with instant data updates for each entity. With comprehensive risk assessments across eight risk categories, Risk Scan transforms your risk management from reactive to a proactive strategic advantage.",
    Select: "Select",
    Upload: "Upload",
    Cancel: "Cancel",
    Confirm: "Confirm",
    UploadFiles: "Upload Files",
    PleaseuploadyourfileinCVSformat: "Please upload your file in xlsx format.",
    Downloadxlsxtemplate: "Download xlsx template",
    Xcompanieswereuploadedsucessfuly: "{0} companies were uploaded sucessfuly.",
    Xcompanieswereidentifiedsucessfuly:
      "{0} companies were identified sucessfuly.",
    Xcompanieswerenotmatched: "{0} companies were not matched.",
    Uploadingfilefailed:
      "Uploading file failed. Please use the template and try again.",
    Uploading: "Uploading",
    Uploadwithamaximumfilesizeof1M:
      "(Maximum of 100 data entries can be uploaded at a time, with a maximum file size of 1MB.)",
    Tryagain: "Try again",
    Theuploadedonlyxlsx: "The uploaded file can only be in xls/xlsx format",
    Scanning: "Scanning",
    RiskScanning: " Risk Scanning",
    Youhaveselectedatotalof: "You have selected",
    Tostartriskscanning: 'companies. Click "Confirm" to begin scanning.',
    Datascanningisinprogress: "Data scanning is in progress",
    LastUpdate: "Last Update",
    Selectdate: "Select date",
    UpdateStatus: "Update Status",
    ClearAll: "Clear All",
    ALL: "ALL",
    Updated: "Updated",
    Notupdated: "Not updated",
    HistoricalData: "Historical Data",
    Selectrisklevel: "Select risk level",
    Low: "Low",
    Average: "Average",
    Caution: "Caution",
    NotRated: "Not Rated",
    Reselect: "Reselect",
    HistoricalRecords: "Historical Records",
    DownloadReport: "Download Report",
    SearchLeads: "Search Leads",
    CompanyName: "Co. Name",
    CompanyID: "Co. ID",
    CompanyType: "Co. Type",
    RegistrationDate: "Registration Date",
    RegistrationStatus: "Registration Status",
    Listed: "Listed",
    LegalStatus: "Legal Status",
    NoofShareholders: "No. of Shareholders",
    ShareholdingLayers: "Shareholding Layers",
    NoofCorporateShareholders: "No. of Corporate Shareholders",
    NoofNatualPersonShareholders: "No. of Natual Person Shareholders",
    RelatedCompanies: "Related Companies",
    OrganizationalStatus: "Organizational Status",
    OperatingAddress: "Operating Address",
    IndustryCode: "Industry Code",
    BusinessActivities: "Business Activities",
    NoofEmployees: "No. of Employees",
    Management: "Management",
    CurrentOperations: "Current Operations",
    Revenue: "Revenue",
    Assests: "Assests",
    ProfitLoss: "Profit/Loss",
    Liquidity: "Liquidity",
    Growth: "Growth",
    Performance: "Performance",
    CreditRating: "Credit Rating",
    CreditScore: "Credit Score",
    PausibilityofDefault: "Pausibility of Default (PD)",
    SolvencyIndex: "Solvency Index",
    DebtCollection: "Debt Collection",
    CreditOpinion: "Credit Opinion",
    CompanySanction: "Co. Sanction",
    ProductSanction: "Product Sanction",
    ExportControl: "Export Control",
    AntiCorruptionAntiBribery: "Anti-Corruption & Anti-Bribery",
    Litigations: "Litigations",
    NegativeNews: "Negative News",
    ESGScore: "ESG Score",
    YearsinBusiness: "Years in Business",
    Competitiveness: "Competitiveness",
    WorkingCapital: "Working Capital",
    FinancialStructure: "Financial Structure",
    Industrystatus: "Industry status",
    IndustryOutlook: "Industry Outlook",
    NoofCompanies: "No. of Companies",
    IndustryRanking: "Industry Ranking",
    IndustryConcentration: "Industry Concentration",
    IndustryCompetitiveness: "Industry Competitiveness",
    IndustryDevelopment: "Industry Development",
    Legal: "Legal",
    Organizational: "Organizational",
    Operational: "Operational",
    Financial: "Financial",
    Credit: "Credit",
    Compliance: "Compliance",
    Sustainability: "Sustainability",
    Industry: "Industry",
    ScanDate: "Scan Date",
    Updating: "Updating",
    ScanHistoricalData: "Scan Historical Data",
    StartDate: "Start Date",
    EndDate: "End Date",
    Download: "Download",
    Entercompanyname: "Enter company name",
  },
  //Data Management
  DataManagement: {
    DataManagement: "Data Management",
    AllCompanies: "All Companies",
    CompaniesViewed: "Companies Viewed",
    CompaniesCollected: "Companies Collected",
    CompaniesUploaded: "Companies Uploaded",
    MyPortfolio: "My Portfolio",
    Date: "Date",
    CompanyName: "Co. Name",
    Country: "Country",
    CompanyType: "Co. Type",
    CompanyStatus: "Co. Status",
    DQI: "DQI",
    Download: "Download",
    Addcompanies: "Add companies",
    Filter: "Filters",
    Selectcountry: "Select Country",
    Selectindustry: "Select Industry",
    Selectcompanytype: "Select company type",
    Selectcompanysize: "Select company size",
    Selectcompanystatus: "Select company status",
    Selectlistedcompanies: "Select listed companies",
    Selectcompanyyearsinbusiness: "Select company years in business",
    Industry: "Industry",
    CompanySize: "Co. Size",
    Listed: "Listed",
    CompanyAge: "Co. Age",
    SelectYear: "Select Year",
    SelectQuarter: "Select Quarter",
    SelectMonth: "Select Month",
    Reset: "Reset",
    Search: "Search",
    MyDatabase: "My Database",
    Locations: "Locations",
    YearsinBusiness: "Years in Business",
    CompanyDQI: "Co. DQI",
    RiskScan: "Risk Scan",
    CreditAssessment: "Credit Assessment",
    Uptodate: "Up to date",
    Average: "Average",
    Insufficient: "Insufficient",
    Good: "Good",
    Caution: "Caution",
    Unknown: "Unknown",
    CompanyTag: "Co. Tag",
    Remove: "Remove",
    Uploaded: "Uploaded",
    Identified: "Identified",
    Notmatched: "Not matched",
    UploadCompanies: "Upload Companies",
    Match: "Match",
    Delete: "Delete",
    OnlineMatching: "Online Matching",
    Identifythecompanywithmanualcheck: "Identify the company with manual check",
    Identifyacompanymanually: "Identify a company manually",
    Pleaseprovideanyrelevantinformation:
      "Please provide any relevant information that could enhance the search results. Our data analyst will match you with the most suitable company.",
    RegistrationID: "Registration ID",
    StateProvince: "State/Province",
    Address: "Address",
    Otherinformation: "Other information",
    Submit: "Submit",
    Cancel: "Cancel",
    Confirm: "Confirm",
    EnterRegistrationID: "Enter Registration ID",
    EnterAddress: "Enter Address",
    EnterInformation: "Enter Information",
    User: "User",
    Task: "Task",
    NoofCompanies: "No. of Companies",
    Entercompanyname: "Enter company name",
    SaveYourPortfolio: "Save Your Portfolio",
    PortfolioName: "Portfolio Name",
    Notes: "Notes",
    Edit: "Edit",
    EnterPortfolioName: "Enter Portfolio Name",
    EnterUserName: "Enter User",
    SelectTaskName: "Select Task",
    EnterNotes: "Enter Notes",
    StartingMonth: "Starting Month",
    EndMonth: "End Month",
  },

  Relationship: {
    SearchRelationship: "Search Relationship",
    SearchRelationshipInfo:
      " is our premier data service designed to illuminate the complete corporate ecosystem of any business. The platform delivers a comprehensive 360-degree view of your subject company, revealing:",
    UltimateOwnershipControl: "Ultimate Ownership & Control",
    UltimateOwnershipControlInfo:
      "Unmask the chain of ownership by tracing through complex layers to identify UBOs and all shareholders.",
    InvestmentParticipation: "Investment & Participation",
    InvestmentParticipationInfo:
      "Discover every company the subject has invested in, partnered with, or participated in, uncovering strategic directions and hidden alliances.",
    SupplyChainNetwork: "Supply Chain Network",
    SupplyChainNetworkInfo:
      "Map the spectrum of commercial relationships, identifying all possible vendors and clients to understand the full flow of commerce.",
    Ourplatformempowers:
      "Our platform empowers your critical decisions by helping you discover opportunities, streamline compliance, and mitigate risk. With Search Relationship, transparency is just a search away.",
    LetsBegin: "Let's Begin",
    CompanyName: "Co. Name",
    Country: "Country",
    Industry: "Industry",
    CompanyType: "Co. Type",
    CompanySize: "Co. Size",
    CompanyStatus: "Co. Status",
    ListingInfo: "Listing Info",
    YearsinBusiness: "Years in Business",
    IncDate: "Inc. Date",
    HSCode: "Hs Code",
    Company: "Company",
    Product: "Product",
    HsCodeProduct: "Hs Code / Product",
    ImportExport: "Import & Export",
    Entercompanyname: "Enter company name",
    SelectHsCodeProduct: "Select Hs Code / Product",
    CompanySnapshot: "Company Snapshot",
    Address: "Address",
    CountyCity: "County/City",
    ProvinceState: "Province/State",
    CountryRegion: "Country/Region",
    ZipCode: "Zip Code",
    RegName: "Registered Name",
    Website: "Website",
    Email: "Email",
    Phone: "Phone",
    LastUpdate: "Last Update",
    DataSource: "Data Source",
    CompanyProfile: "Company Profile",
    CoNativeName: "Co. Native Name",
    CompanyID: "Co. ID",
    VATNumber: "VAT Number",
    StockNumber: "Stock Number",
    Listed: "Listed",
    RegistrationDate: "Registration Date",
    LegalForm: "Legal Form",
    LegalStatus: "Legal Status",
    Jurisdiction: "Jurisdiction",
    RegisteredAddress: "Registered Address",
    OperatingAddress: "Operating Address",
    Ownership: "Ownership",
    Investments: "Investments",
    PossibleVendors: "Possible Vendors",
    PossibleClients: "Possible Clients",
    UItimateBeneficiaryOwner: "Ultimate Beneficiary Owner (UBO)",
    ControllingShareholder: "Controlling Shareholder",
    Participations: "Participations",
    ShareholdingLayers: "Shareholding Layers",
    PartiesInvolved: "Total Parties Involved",
    RelatedCompanies: "Related Companies",
    CompanyShareholders: "Company Shareholders",
    CoShareholders: "Co. Shareholders",
    NGOShareholders: "NGO Shareholders",
    NaturalPersonShareholders: "Natural Person Shareholders",
    SubjectsInvestments: "Subject's Investments",
    CorporateShareholders: "Corporate Shareholders",
    Name: "Name",
    Location: "Location",
    Type: "Type",
    Shares: "Shares (%)",
    Relations: "Relations",
    TotalEntities: "Total Entities",
    Entities: "Entities",
    Subsidiaries: "Subsidiaries",
    Countries: "Countries",
    Branches: "Branches",
    Relationship: "Relationship",
    RelationType: "Relation Type",
    RelationLevel: "Relation Level",
    Management: "Management",
    ContactInfo: "Contact Info",
    Position: "Position",
    Department: "Department",
    ShareholderorNot: "Shareholder or Not",
    Pleaseentername: "Please enter name",
    SupplyChain: "Supply Chain",
    PossibleClients: "Possible Clients",
    PossibleSuppliers: "Possible Suppliers",
    Banking: "Banking",
    TotalSales: "Total Sales",
    TotalPurchasing: "Total Purchasing",
    ActivePlayers: "Active Players",
    MainProductsServices: "Main Products/Services",
    TotalTradingVolume: "Total Trading Volume",
    TransactionTotal: "Transaction/Total (%)",
    RecentTradeDate: "Recent Trade Date",
    IndustryCode: "Industry Code",
    TradeRelatedCompanies: "Trade Related Companies",
    TradeRelatedProductTOP10: "Trade Related Product TOP 10",
    Numberofshareholderenterprises: "No. of shareholders",
    CurrentLevel: "Current Level",
    SharesonSubjectCo: "Shares on Subject Co.",
    EnterCurrentLevel: "Enter Current Level",
    EnterCountry: "Enter Country",
    ClearAll: "Clear All",
    ShareholderLevel: "Shareholding Levels",
    DirectShareholdingPercentage: "Direct shareholding ratio",
    TotalOwnershipPercentage: "Total shareholding ratio",
    InvestmentHoldingLevel: "Investment Holding Level",
  },
  SearchSanctions: {
    CountryISO: "Country ISO",
    Currency: "Currency",
    Language: "Language",
    SanctionOtherCountries: "Sanction Other Countries",
    SanctionedbyOtherCountries: "Sanctioned by Other Countries",
    CountriesTerritories: "Countries/Territories",
    Selectcountryterritory: "Select Country/Territory",
    Noofcountriessanctionedby: "No. of countries sanctioned by {0}",
    Noofcountriesthatsanctioned: "No. of countries that sanctioned {0}",
    Noofsanctionedcompanies: "No. of sanctioned companies",
    Noofsanctionedpersonnel: "No. of sanctioned personnel",
    SanctionOverview: "Sanction Overview",
    NoofSanctions: "No. of Sanctions",
    TypesofSanctions: "Types of Sanctions",
    SourceofSanctions: "Source of Sanctions",
    Provider: "Provider",
    Description: "Description",
    Details: "Details",
    ClearAll: "Clear All",
    Sanctions: "Sanctions",
    SanctionID: "Sanction ID",
    SelectsanctionID: "Select sanction ID",
    SanctionedType: "Sanctioned Type",
    SelectSanctionedType: "Select Sanctioned Type",
    CompanyPersonnel: "Company/Personnel",
    Selectcompanypersonnel: "Select Company/Personnel",
    SanctionCategory: "Sanction Category",
    Selectsanctioncategory: "Select Sanction Category",
    SanctionSource: "Sanction Source",
    Selectsanctionsource: "Select Sanction Source",
    Status: "Status",
    Selectstatus: "Select status",
    CountryofSource: "Country of Source",
    Name: "Name",
    SanctionedCountries: "Sanctioned Countries",
    SanctionType: "Sanction Type",
    Reference: "Reference",
    ProviderCode: "Provider Code",
    RecordSource: "Record Source",
    CompanyName: "Co. Name",
    Country: "Country",
    SelectCompanyName: "Select Company Name",
    SelectCountry: "Select Country",
    SanctionInfo: "Sanction Info",
    SanctionRelated: "Sanction Related",
    OwnershipRelatedCompanies: "Ownership & Related Companies",
    OfficialSanctionList: "Official Sanction List",
    RegName: "Reg. Name",
    Address: "Address",
    Website: "Website",
    Email: "Email",
    ProvinceState: "Province/State",
    Tel: "Tel",
    CountryRegion: "Country/Region",
    LastUpdate: "Last Update",
    ZipCode: "Zip Code",
    DataSource: "Data Source",
    Relations: "Relations",
    ProfileNotes: "Profile Notes",
    DOB: "DOB",
    Gender: "Gender",
    All: "All",
    FirstName: "First Name",
    MiddleName: "Middle Name",
    LastName: "Last Name",
    PreviousName: "Previous Name",
    Type: "Type",
    PlaceofBirth: "Place of Birth",
    Citizenship: "Citizenship",
    Residence: "Residence",
    Juristiction: "Juristiction",
    History: "History",
    Category: "Category",
    Title: "Title",
    SanctionRecord: "Sanction Record",
    Relationship: "Relationship",
    HSCode: "HS Code",
    ProductName: "Product Name",
    SanctionedCountryRegion: "Sanctioned Country/Region",

    //未对应
    LawEnforcement: "Law Enforcement",
    EnforcementOrders: "Enforcement Orders",
    Warnings: "Warnings",
    FinancialSanctions: "Financial Sanctions",
    ExclusionList: "Exclusion List",
    TradeRestrictions: "Trade Restrictions",
    VisaTravelBan: "Visa/Travel Ban",
    WarCrimes: "War Crimes",
    NoData: "No Data",
    Advisories: "Advisories",
    Others: "Others",
    Selectsanctiontype: "Select Sanction Type",
    Selectreference: "Select Reference",
    From: "From",
    To: "To",
    CountryCity: "Country/City",
    Sources: "Sources",

    SearchPersonName: "Search Person Name",
    SelectDOB: "Select DOB",
    Male: "Male",
    Female: "Female",
    SelectRecordSource: "Select Record Source",
    DescriptionofReferenceName: "Description of Reference Name",
    SelectHSCode: "Select HS-Code",
    SelectProductName: "Select Product Name",
    SelectSanctionedCountryRegion: "Select Sanctioned Country/Region",
  },
  SearchTrade: {
    LastUpdate: "Last Update",
    ProductCode: "Product Code",
    ProductDescription: "Product Description",
    Sanctions: "Sanctions",
    TotalImports: "Total Imports",
    TotalExports: "Total Exports",
    TotalImportWeight: "Total Import Weight",
    TotalExportWeight: "Total Export Weight",
    NumberofSuppliers: "No. of Suppliers",
    NumberofBuyers: "No. of Buyers",
    NumberofOriginCountries: "No. of Origin Countries",
    NumberofDestinationCountries: "No. of Destination Countries",
    TradeMap: "Trade Map",
    Imports: "Imports",
    Exports: "Exports",
    Reset: "Reset",
    Product: "Product",
    Destination: "Destination",
    Origin: "Origin",
    NoData: "No Data",
    Date: "Date",
    TotalTransactions: "Total Transactions",
    Transactions: "Transactions",
    TradeRanking: "Trade Ranking",
    Top5Ranking: "Top 5 Ranking",
    Growth: "Growth",
    Decline: "Decline",
    TradeTrends: "Trade Trends",
    TradeVolume: "Trade Volume",
    MonthonMonthRatio: "Month-on-Month Ratio",
    Suppliers: "Suppliers",
    Buyers: "Buyers",
    Startdate: "Start date",
    Enddate: "End date",
    SelectCountry: "Select Country",
    SelectCompany: "Select Company",
    ClearAll: "Clear All",
    TransactionDate: "Transaction Date",
    SelectTransactionDate: "Select Trade Date",
    Company: "Company",
    CompanyName: "Co. Name",
    Country: "Country",
    Industry: "Industry",
    Enterkeywords: "Enter Keywords",
    SupplierOverview: "Supplier Overview",
    BuyerOverview: "Buyer Overview",
    CompanyID: "Co. ID",
    ISIC: "ISIC",
    ISICDescription: "ISIC Description",
    TotalTradeAnnual: "Total Trade (Annual)",
    TotalTradePastsixmonth: "Total Trade (Past 6 mo)",
    ContactInformation: "Contact Information",
    ShippingOverview: "Shipping Overview",
    TradeHistoryandTrends: "Trade History and Trends",
    SupplyChainList: "Supply Chain List",
    PossibleBuyers: "Possible Buyers",
    PossibleSuppliers: "Possible Suppliers",
    ShowAll: "Show All",
    TotalExportsAnnual: "Total Exports (Annual)",
    TotalImportsAnnual: "Total Imports (Annual)",
    ExportAmount: "Export Amount",
    ImportAmount: "Import Amount",
    ShipmentDetail: "Shipment Detail",
    Entersuppliername: "Enter Supplier Name",
    Enterbuyername: "Enter Buyer Name",
    SupplierName: "Supplier Name",
    BuyerName: "Buyer Name",
    TotalAmount: "Total Amount",
    Details: "Details",
    WaybillDetails: "Waybill Details",
    ListofOrigins: "List of Origins",
    ListofDestinations: "List of Destinations",
    ISO: "ISO",
    Currency: "Currency",
    Language: "Language",
    Address: "Address",
    OverviewofSupplyChainInformation: "Overview of Supply Chain Information",
    OriginInformationOverview: "Origin Information Overview",
    DestinationInformationOverview: "Destination Information Overview",
    SanctionType: "Sanction Type",
    SelectSanctionType: "Select Sanction Type",
    SanctionedCountryRegion: "Sanctioned Country/Region",
    SelectSanctionedCountryRegion: "Select Sanctioned Country/Region",
    HSCode: "HS Code",
    SanctionedProductsOverview: "Sanctioned Products Overview",
    Searchmoresanctiononothercompanies:
      "Search more sanction on other companies",
    SimilarProducts: "Similar Products",
    Numberofsimilarproducts: "No. of similar products",
    TopImportCountries: "Top 5 Import Countries",
    TopExportCountries: "Top 5 Export Countries",
    PleaseSelect: "Please Select",
    EnterHSCodeProductName: "Enter HS Code &  Product Name",
    ImportProducts: "Import Products",
    ExportProducts: "Export Products",
    NumberofOrigin: "No. of Origin",
    NumberofDestination: "No. of Destination",
    NumberofImportProducts: "No. of Import Products",
    NumberofExportProducts: "No. of Export Products",
    ProductName: "Product Name",
    SelectProductName: "Select Product Name",
    TopExportProducts: "Top 5 Export Products",
    TopImportProducts: "Top 5 Import Products",
    ExportProductOverview: "Export Product Overview",
    ImportProductOverview: "Import Product Overview",
    CompanyCompetitiveness: "Company Competitiveness",
    GlobalMarketShare: "Global Market Share",
    RegionalMarketShare: "Regional Market Share",
    BusinessGrowthGlobalMarket: "Business Growth (Global Market)",
    BusinessGrowthRegionalMarket: "Business Growth (Regional Market)",
    CreditRating: "Credit Rating",
    CreditAssessment: "Credit Assessment",
    LocalCreditScore: "Local Credit Score",
    SolvencyIndex: "Solvency Index",
    ProbabilityofDefault: "Probability of Default",
    RiskIndicator: "Risk Indicator",
    CreditLine: "Credit Line",
    RelatedCreditAssessment: "Related Credit Assessment",
    HighRisk: "High Risk",
    Medium: "Medium",
    Moderate: "Moderate",
    Average: "Average",
    LowerThanAvg: "Lower Than Avg",
    LowRisk: "Low Risk",
    CreditOpinion: "Credit Opinion",
    ComparisonofSimilarProducts: "Comparison of Similar Products",
    AddProduct: "Add Product",

    RegistrationDate: "Registration Date",
    Profit: "Profit",
    NoofShareholders: "No. of Shareholders",
    TotalAssets: "Total Assets",
    IndustryCode: "Industry Code",
    CreditRating: "Credit Rating",
    NoofEmployees: "No. of Employees",
    CreditScore: "Credit Score",
    Listed: "Listed",
    ESGRating: "ESG Rating",
    Revenue: "Revenue",
    DQI: "DQI",
    MoreCoDetails: "More Co. Details",
    CoNews: "Co. News",
    MoreCoNews: "More Co. News",
    IndustryMean: "Industry Mean",
    TargetSubjectRevenue: "Target Subject Revenue",
    ImportCountries: "Import Countries",
    ExportCountries: "Export Countries",
    ImportCompanyTop: "Import Company Top 1",
    ExportCompanyTop: "Export Company Top 1",
    TopImportCountry: "Top Import Country",
    TopExportCountry: "Top Export Country",
    Max: "Max",
    Min: "Min",
    Subject: "Subject",
    ReturnonEquity: "Return on Equity",
    ProfitMargin: "Profit Margin",
  },

  TradeByCountry: {
    ImpExpCountries: "Imp & Exp Countries",
    ImpExpCompanies: "Imp & Exp Companies",
    ImpExpProducts: "Imp & Exp Products",
    Assessment: "Assessment",
    TotalImportAmount: "Total Import Amount",
    GlobalImportShare: "Global Import Share",
    ImportGrowth: "Import Growth",
    TotalExportAmount: "Total Export Amount",
    GlobalExportShare: "Global Export Share",
    ExportGrowth: "Export Growth",
    TradeBalance: "Trade Balance",
    CountryData: "Country Data",
    GDP: "GDP",
    GDPPPP: "GDP (PPP)",
    ExportsofGoods: "Exports of Goods",
    ExportsofServices: "Exports of Services",
    ImportsofGoods: "Imports of Goods",
    ImportsofServices: "Imports of Services",
    CPI: "CPI",
    Population: "Population",
    ContainerPortThroughput: "Container Port Throughput",
    DistributionofImportExportCountries:
      "Distribution of Import & Export Countries",
    Top5Ranking: "Top 5 Ranking",
    Importers: "Importers",
    Exporters: "Exporters",
    ImportCountries: "Import Countries",
    ExportCountries: "Export Countries",
    ImportProducts: "Import Products",
    ExportProducts: "Export Products",
    CountryImportExportOverview: "Country Import & Export Overview",
    Year: "Year",
    Amount: "Amount (USD)",
    Balance: "Balance",
    CountryTradeDataComparison: "Country Trade Data Comparison",
    Comparison: "Comparison",
    AddSample: "Add Sample",
    AddCriteria: "Add Criteria",
    ImportCountry: "Import Country",
    Selectimportcountries: "Select Import Countries",
    ExportCountry: "Export Country",
    Selectexportcountries: "Select Export Countries",
    EnterHSCodeProductName: "Enter HS Code &  Product Name",
    Afterselectingthecriteria:
      "After selecting the criteria, the comparison result will be displayed.",
    ShowResult: "Show Result",
    ListofTradeCompanies: "List of Trade Companies",
    TotalCompanies: "Total Companies",
    Top5Products: "Top 5 Products",
    ListofExportProducts: "List of Export Products",
    ListofImportProducts: "List of Import Products",
    Top5ExportCountries: "Top 5 Export Countries",
    Top5ImportCountries: "Top 5 Import Countries",
    HSDescription: "HS Description",
    HSCode: "HS Code",

    TradeCompetitivenessIndex: "Trade Competitiveness Index",
    TotalTradeAmount: "Total Trade Amount",
    NetTradeBalance: "Net Trade Balance",
    TradeGap: "Trade Gap",
    TradeGoodsExports: "Trade Goods Exports",
    TradeGoodsImports: "Trade Goods Imports",
    TradeServicesExports: "Trade Services Exports",
    TradeServicesImports: "Trade Services Imports",
    CompositePMI: "Composite PMI",
    ServicesPMI: "Services PMI",
    LegalEnvironment: "Legal Environment",
    CorporateTaxRate: "Corporate Tax Rate",
    PersonalIncomeTaxRate: "Personal Income Tax Rate",
    SalesTaxRate: "Sales Tax Rate",
    BusinessConfidenceIndex: "Business Confidence Index",
    CountryRating: "Country Rating",
    CompetitivenessIndex: "Competitiveness Index",
    CompetitivenessRank: "Competitiveness Rank",
    EaseofDoingBusiness: "Ease of Doing Business",
    BusinessConfidence: "Business Confidence",
    ConsumerConfidence: "Consumer Confidence",
    BusinessClimateAssessment: "Business Climate Assessment",
    SP: "S&P",
    Moodys: "Moody's",
    Fitch: "Fitch",
    DBRS: "DBRS",
    Allianz: "Allianz",
    Coface: "Coface",
    Atradius: "Atradius",
    OECD: "OECD",
    Productivecapacitiesindex: "Productive Capacities Index",
    PleaseSelect: "Please Select",
    transactionvolume: "Transaction Volume",
    Growth: "Growth",
    Decline: "Decline",
    SelectCountry: "Select Country",
    TradeVolume: "Trade Volume",
    Youcanonlyaddupto5datacomparisonitems:
      "You can only add up to 5 data comparison items",
    DataComparisonActive: "DataComparisonActive",
    DataComparisonBlack: "DataComparisonBlack",
    ProductName: "Product Name",
    Product: "Product",
    EnterproductnameorHSCode: "Enter Poduct Name or HS Code",
    Date: "Date",
    OverviewofAnalysisContent: "Overview of Analysis Content",
    Afterselectingthecriteria: "After selecting the criteria,",
    thecomparisonresultwillbedisplayed:
      "the comparison result will be displayed.",
    ImportExport: "Import & Export",
    All: "All",
    Company: "Company", //Company
    SelectCompanyName: "Select Company Name",
    SelectProductName: "Select Product Name",
    CompanyID: "Co. ID",
    CO: " C/O",
    ISIC: "ISIC",
    ISICDescription: "ISIC Description",
    Top5ExportProducts: "Top 5 Export Products",
    Top5ImportProducts: "Top 5 Import Products",
    ContactInformation: "Contact Information",
    SearchTrade: "Search Trade",
    NumberofImportProducts: "No. of Import Products",
    NumberofExportProducts: "No. of Export Products",
    TransactionYear: "Transaction Year",
    SelectTransactionYear: "Select Transaction Year",
    Totalnumberofimportedproducts: "Total number of Imported products",
    Totalnumberofexportedproducts: "Total number of Exported products",
    Updateyear: "Update year",
    TotalTrade: "Total Trade",
    ISO: "ISO",
    Currency: "Currency",
    Language: "Language",
  },
  LeadsAIAssistance: {
    SavedAnswers: "Saved Answers",
    SearchLeads: "Search Leads",
    SearchLeadsMessage1:
      "Search Leads is a powerful tool designed to help business users connect with potential customers or vendors. Driven by cutting-edge machine learning technology, our platform analyzes extensive datasets to deliver tailored and precise recommendations.",
    SearchLeadsMessage2:
      "The system takes into account user goals, market trends, risk tolerance, and historical data to pinpoint products or services that best match their specific needs and preferences.",
    SearchLeadsMessage3:
      'Continuously learning and evolving, "Search Leads" ensures its recommendations remain relevant and accurate. By offering actionable insights, it empowers businesses to save time and resources while identifying the most promising customers or vendors.',
    SearchLeadsMessage4:
      "In order for the system to recommend a list of companies, we need you to answer few questions.",
    LetBegin: "Let's Begin",
    Selectallthatapply: "Select all that apply",
    Savemyanswers: "Save my answers",
    Showresults: "Show results",
    Yoursearchcriteriaforcustomeracquisition:
      "Your search criteria for customer acquisition",
    Doyouliketosaveyourcurrentselectionsofsearchcriteria:
      "Do you like to save your current selections of search criteria?",
    Pleasenameyourcondition: "Please name your condition",
    Pleaseenterthetemplatename: "Please enter the template name",
    NoSave: "No Save",
  },
  SearchLeadsList: {
    Filters: "Filters",
    Questionnaire: "Questionnaire",
    Country: "Country",
    CompanyType: "Co. Type",
    CompanySize: "Co. Size",
    OperationalStatus: "Operational Status",
    YearsinBusiness: "Years in Business",
    NumberofEmploees: "No. of Emploees",
    Fortune500: "Fortune 500",
    Listed: "Listed",
    ImportExport: "Import & Export",
    TotalAssets: "Total Assets",
    Revenue: "Revenue",
    Profitability: "Profitability",
    CreditRating: "Credit Rating",
    Foundover: "Found over",
    Changeseach: "Change seach",
    Refreshformore: "Refresh for more",
    CompanyNumber: "Co. ID",
    Address: "Address",
    Lockinlist: "Lock in list",
    ContactInformation: "Contact Information",
    SupplyChainList: "Supply Chain List",
    IndustryInfo: "Industry Info",
    LeadScore: "Lead Score",
    AccuracyScale: "Accuracy Scale",
    RegistrationDate: "Registration Date",
    Profit: "Profit",
    NoofShareholders: "No. of Shareholders",
    TotalAssets: "Total Assets",
    IndustryCode: "Industry Code",
    CreditRating: "Credit Rating",
    NoofEmployees: "No. of Employees",
    CreditScore: "Credit Score",
    Listed: "Listed",
    ESGRating: "ESG Rating",
    Revenue: "Revenue",
    DQI: "DQI",
    MoreCoDetails: "More Co. Details",
    CoNews: "Co. News",
    MoreCoNews: "More Co. News",
    NationalIndustryData: "National Industry Data",
    LastUpdate: "Last Update",
    IndustryandCountryOverview: "Industry and Country Overview",
    CountryName: "Country Name",
    BusinessEnvironment: "Business Environment",
    LegalEnvironment: "Legal Environment",
    ConfidenceIndex: "Confidence Index",
    NationalCompetitivenessIndex: "National Competitiveness Index",
    NationalGDP: "National GDP",
    Industrysituationoftheaffiliatedcompany:
      "Industry situation of the affiliated company",
    Subjectcompanyindustrydescription: "Subject company industry description",
    Targetenterpriseindustrycode: "Target enterprise industry code",
    Industryscalesegmentation: "Industry scale segmentation",
    Quantity: "Quantity",
    SubjectCompany: "Subject Company",
    // Large:"Large",
    // Micro:"Micro",
    // SME:"SME",
    // Medium:"Medium",
    Industryyearsegmentation: "Industry year segmentation",
    Industryoperationsituation: "Industry operation situation",
    Tips: "Tips",
    Areyousureyouwanttodeletethisdata:
      "Are you sure you want to delete this data",
  },
  SearchLeadsContact: {
    ContactInformation: "Contact Information",
    OrganizationalFramework: "Organizational Framework",
    NumberofPersonnel: "No. of Personnel",
    NumberofDepartments: "No. of Departments",
    NumberofCalls: "No. of Calls",
    NumberofEmails: "No. of Emails",
    MiningRate: "Mining Rate",
    AuthenticationRate: "Authentication Rate",
    Name: "Name",
    Department: "Department",
    Position: "Position",
    Country: "Country",
    Email: "Email",
    Phone: "Phone",
    SocialMediaAccounts: "Social Media Accounts",
    AuthenticationStatus: "Authentication Status",
    AddStatus: "Add Status",
    Doyouhaveanemailaddress: "Do you have an email address?",
    Isthereatelephone: "Is there a telephone?",
    Authenticationrequired: "Authentication required",
    Addornot: "Add or not?",
    Added: "Added",
    BulkEmailSending: "Bulk Email Sending",
    BatchAuthentication: "Batch Authentication",
    AddCustomers: "Add Customers",
    AIEmailAssistant: "AI Email Assistant",
    ClearAll: "Clear All",
    EnterName: "Enter Name",
    EnterDepartment: "Enter Department",
    EnterPosition: "Enter Position",
    EnterCountry: "Enter Country",
    Yes: "Yes",
    No: "No",
    EnterSocialMediaAccount: "Enter Social Media Account",
    Certified: "Certified",
    Unverified: "Unverified",
    InformationAuthentication: "Information Authentication",
    AuthenticationMethod: "Authentication Method",
    Iwanttoclaimit: "I want to claim it",
    IwanttoclaimitMessage: "You can authenticate people you know.",
    AuthenticationService: "Authentication Service",
    AuthenticationServiceMessage:
      "You can select the personnel you want to authenticate and initiate offline authentication service to the system.",
    UploadedList: "Uploaded List",
    DownloadTemplate: "Download Template",
    Upload: "Upload",
    ListofCertifiedPersonnel: "List of Certified Personnel",
    AIEmailAssistantTitle: "Thank you for using AI Email Assistant",
    AIEmailAssistantMessage:
      "We will use artificial intelligence to delve deeper into the target company's personnel and contact information.",
    EmailSending: "Email Sending",
    RecipientInformation: "Recipient Information",
    SelectedList: "Selected List",
    Pleaseenteryourname: "Please enter your name",
    SenderInformation: "Sender Information",
    CompanyName: "Co. Name",
    EmailContent: "Email Content",
    EmailConfirmationMessage: "Email Confirmation Message",
    Hellodearuser: "Hello dear user",
    Message:
      "The sender of this email has found your company's contact information through the CSI platform and hopes to establish contact with you. You can directly reply to the email to establish a business relationship with it or send an email to the platform's customer service, and the system will contact the user for you.",
    CSIWebsite: "CSI Website",
    CSICustomerServiceEmail: "CSI Customer Service Email",
    EnterCompanyName: "Enter Company Name",
    EnterEmail: "Enter Email",
    EnterPhone: "Enter Phone",
    Pleaseenteremailcontent: "Enter Email Content",
    Cancel: "Cancel",
    Submit: "Submit",
    Return: "Return",
    Close: "Close",
    All: "All",
    Addcustomerconfirmationlist: "Add customer confirmation list",
    AddCustomersMessage:
      "Please confirm whether it is necessary to add the individuals in the table to my client list. (Personal Center)",
    Addlist: "Add list",
  },

  ...enLocale,
};

export default en;
